































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size } from "../../../../../../base/domain/drawing";
import { StandardKeyboardHandler } from "../../../../../../base/components/system/keyboard";
import { PdfStyleDrawableMixin } from "../../../../../../base/components/system/mixins";
import { CommonComponentsAccessibleMixin } from "../../mixins";
import { default as QuestionnaireFormatPageObjectsSelector } from "./QuestionnaireFormatPageObjectsSelector.vue";
import { FormatPageMouseTrackableMixin, ObjectUpdatesPromptableMixin } from "./mixins";

@Component({
  components: {
    StandardKeyboardHandler,
    QuestionnaireFormatPageObjectsSelector,
  }
})
export default class QuestionnaireFormatPageInputTracker extends Mixins(FormatPageMouseTrackableMixin, ObjectUpdatesPromptableMixin, CommonComponentsAccessibleMixin, PdfStyleDrawableMixin) {
  @Prop()
  isActive: boolean;

  @Prop({ default: () => new Size(10, 10) })
  gridSize: Size;

  @Prop()
  containerStyle: CSSStyleDeclaration;

  get scaledStyleProperties() {
    // transform scaleを指定するとelement-uiのel-dialogのモーダル表示がおかしくなってしまう
    // modalAppendToBody="false"を指定するとモーダル表示は正しくなるが、文書編集画面のscrollに依存する表示になってしまう
    // appendToBody="true"を指定すると概ね良さそうな表示になる。親から引き継がれていたcss指定が無くなるのでそこだけ注意が必要
    return {
      transform: "scale(" + this.scale + ", " + this.scale + ")",
      transformOrigin: "left top",
    };
  }

  $refs!: {
    focusTarget: HTMLElement,
    selector: QuestionnaireFormatPageObjectsSelector,
  };

  isFocus: boolean = false;

  handleMouseDowned(event: PointerEvent): void {
    // オブジェクトが拾ってない場合だけここに来る.
    this.promptForObjectUpdates(event);
    if (this.pageElement) {
      this.$refs.selector.select(event);
    }
    this.$nextTick(() => this.deselectAllObjects());
  }

  handleMouseUpped(event: PointerEvent): void {
    // selectorが表示される前にマウスリリースされた場合だけここに来る.(はず...)
    this.$refs.selector.cancel();
  }

  handleMoving(offset: Size): boolean {
    if (!this.hasSelectedObjects) {
      return false;
    }
    return true;
  }

  handleMoved(offset: Size): boolean {
    if (!this.hasSelectedObjects) {
      return false;
    }
    const moveOffset = offset.toPoint();
    if (moveOffset.y < 0 && this.isLowerable) {
      this.lowerSelectedObjects();
    } else if (moveOffset.y > 0 && this.isRaisable) {
      this.raiseSelectedObjects();
    }
    return true;
  }

  handleAllSelected(): boolean {
    this.selectAllObjects();
    return true;
  }

  handleDeleted(): boolean {
    this.getCommonComponents().getObjectsRemover().confirmAndRemove();
    return true;
  }

  handleUndone(): boolean {
    this.getCommonComponents().undo();
    return true;
  }

  handleRedone(): boolean {
    this.getCommonComponents().redo();
    return true;
  }

  handleCopied(): boolean {
    this.getCommonComponents().getClipboardManager().clipSelectedObjects();
    return true;
  }

  handlePasted(): boolean {
    const lastSelectedObject = this.objects.slice().reverse().find(o => o.isSelected());
    const index = this.objects.indexOf(lastSelectedObject);
    this.getCommonComponents().getClipboardManager().pasteObjects(new Point(), index >= 0 ? index + 1 : undefined);
    return true;
  }

  resetFocus(): void {
    // タブの移動で編集画面の外に出る場合にフォーカスを戻す.(編集画面外にフォーカスが移動して迷子になるのを防ぐ.)
    this.$doWhenValid(t => t.focus(), this.$refs.focusTarget);
  }
}
